import React, { useContext } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

import {
  DesktopRegister,
  MobileRegisterPersonal,
  Final,
  MobileAddressPage,
  MobileContactPage,
  ConfirmData,
  Payment,
} from '../pages';
import Navigator from '../components/Navigator';
import { AppContext } from '../context';
import QueryRedirect from './QueryRedirect';
import DeactivationMessage from '../components/DeactivationMessage';

const Routes = () => {
  const { isMobile } = useContext(AppContext);
  return (
    <BrowserRouter basename="/capitalizacao">
      <Switch>
        <PrivateRoute exact path="/objetivo" component={DeactivationMessage} />
        <PrivateRoute
          path="/cadastro"
          exact
          dependsOn="productData"
          component={isMobile ? MobileRegisterPersonal : DesktopRegister}
          blockIf="payed"
        />
        {isMobile && (
          <PrivateRoute
            exact
            path="/endereco"
            dependsOn="userData"
            component={MobileAddressPage}
            blockIf="payed"
          />
        )}
        {isMobile && (
          <PrivateRoute
            exact
            path="/contato"
            dependsOn="addressResgistered"
            component={MobileContactPage}
            blockIf="payed"
          />
        )}

        <PrivateRoute
          exact
          path="/confirmacao"
          dependsOn="userData"
          component={ConfirmData}
          blockIf="payed"
        />
        <PrivateRoute
          exact
          path="/pagamento"
          dependsOn="proposal"
          component={Payment}
          blockIf="payed"
        />
        <PrivateRoute dependsOn="payed" path="/final" component={Final} />
        <QueryRedirect from="/" keepQuery to="/objetivo" />
      </Switch>
      <Navigator />
    </BrowserRouter>
  );
};

export default Routes;
